import { cva } from 'class-variance-authority';

export const inputColorMap = {
  accent: 'input-accent',
};

export const inputSizeMap = {
  sm: 'input-sm',
  lg: 'input-lg',
};

export const inputCva = cva('input', {
  variants: {
    color: inputColorMap,
    size: inputSizeMap,
  },
});
